export class MatchingPropertyField {

  static readonly MATCHING_PROPERTY_ID = 'matchingPropertyId';
  static readonly VENDOR_SOURCE = 'vendorSource';
  static readonly CREATED_DATE = 'createdDate';

}



// WEBPACK FOOTER //
// /var/lib/jenkins/jobs/GroupPay/jobs/QA2/jobs/QA-Pioneer-ALL-2-POC/workspace/pioneer-web/src/app/event/models/matching-property-field.ts